import React from 'react';

import * as Api from '../../../../weborder/Api';
import { paymentApiServices } from '../../../../weborder/services';
import {
  Card as CardIcon,
  PaymentApplePay as PaymentApplePayIcon,
  PaymentBancontact as PaymentBancontactIcon,
  PaymentGoogleMicrosoft as PaymentGoogleMicrosoftIcon,
  PaymentIdeal as PaymentIdealIcon,
  PaymentPaypal as PaymentPaypalIcon,
} from '../../../icons';

type PaymentTypeDetails = {
  fdKey: string;
  icon: JSX.Element;
  text: string;
};

const getPaymentTypeDetails = (
  payment: WebOrder.State.Payment,
  translate: any,
): PaymentTypeDetails => {
  let icon: JSX.Element = <CardIcon />;
  let text: string = payment.Description;
  const fdKey = `payment-delete-${payment.paymentId}`;

  switch (payment.PaymentAccountType) {
    case Api.GatewayPaymentAccount.Bancontact: {
      icon = <PaymentBancontactIcon />;
      text = payment.Description;
      break;
    }

    case 'BrainTreePayPalPaymentAccount': {
      icon = <PaymentPaypalIcon />;
      text = `PayPal (${payment.Description.slice(
        payment.Description.indexOf(' '),
      )})`;
      break;
    }

    case 'CardPaymentAccount': {
      icon = <CardIcon />;
      const cardNumber = payment.Description.slice(
        payment.Description.indexOf('*'),
      );
      text = `${translate('Card')} ${cardNumber || ''}`;
      break;
    }

    case 'StripePayButtonPaymentAccount': {
      text = payment.Description;

      if (payment.Description === 'Apple_pay') {
        icon = <PaymentApplePayIcon />;
      } else {
        icon = <PaymentGoogleMicrosoftIcon />;
      }
      break;
    }

    case Api.GatewayPaymentAccount.Ideal: {
      icon = <PaymentIdealIcon />;
      text = payment.Description;
      break;
    }

    default:
      icon = <CardIcon />;
      text = translate(payment.Description, undefined, {
        missingTranslationMsg: payment.Description,
      }) as string;
      break;
  }

  return {
    text,
    icon,
    fdKey,
  };
};

const handleDelete = (
  paymentAccountId: number,
  translate: any,
): Promise<null | string> =>
  paymentApiServices
    .remove({ paymentAccountId })
    .then(() => null)
    .catch(
      (error) =>
        error?.response?.data?.UserMessage ||
        translate('Error_deleting_payment_method'),
    );

export const paymentMethodsUtils = {
  getPaymentTypeDetails,
  handleDelete,
};
